export default {
    adv_types: [],
    categories: null,
    build_types: null,
    repairs: null,
    rooms: null,
    walls: null,
    floors: {sell: null, buy: null},
    stages: null
}